import { Language, MainThemeVariants, StorePersistKeys } from 'src/types'

import UAJSON from 'src/locales/ua.json'
import ENJSON from 'src/locales/en.json'

export const APP_NAME = 'AutoCheckUp'

export const TRANSLATIONS = {
  [Language.UA]: UAJSON,
  [Language.EN]: ENJSON,
}

export const TIME_IN_MS = {
  SECOND: 1000,
  MINUTE: 1000 * 60,
  HOUR: 1000 * 60 * 60,
  DAY: 1000 * 60 * 60 * 24,
}

export const TIME_IN_SECONDS = {
  SECOND: 1,
  MINUTE: 60,
  HOUR: 60 * 60,
  DAY: 60 * 60 * 24,
}

export const DATE_FORMAT = 'PPP'

export const DEFAULT_DEBOUNCED_DELAY = 500

export const CURRENCY_FIELDS = ['totalCost', 'pricePerLiter', 'serviceCost']

export const ITEM_PER_PAGE = 5

export const CURRENT_PAGE_KEY = 'page'

export const ITEM_PER_PAGE_GRID = 9

export const carMakes = [
  'Toyota',
  'Ford',
  'Honda',
  'Chevrolet',
  'Nissan',
  'BMW',
  'Mercedes-Benz',
  'Volkswagen',
  'Audi',
  'Hyundai',
  'Kia',
  'Subaru',
  'Mazda',
  'Lexus',
  'Dodge',
  'Jeep',
  'Tesla',
  'Volvo',
  'Jaguar',
  'Porsche',
]

export enum EngineTypes {
  Petrol = 'Petrol',
  Diesel = 'Diesel',
  Electric = 'Electric',
  Hybrid = 'Hybrid',
  NaturalGas = 'Natural Gas',
}

export const KEYS_FOR_INVALIDATION = [
  StorePersistKeys.USER_CARS,
  StorePersistKeys.MAINTENANCE_HISTORY,
  StorePersistKeys.FUEL_HISTORY,
]

export const LOCALE_DATES = {
  [Language.UA]: 'uk-UA',
  [Language.EN]: 'en-US',
}

export const COLOR_DICTIONARY = {
  [MainThemeVariants.DEFAULT]: '#52525b',
  [MainThemeVariants.RED]: '#dc2626',
  [MainThemeVariants.ROSE]: '#e11d48',
  [MainThemeVariants.ORANGE]: '#ea580c',
  [MainThemeVariants.GREEN]: '#22c55e',
  [MainThemeVariants.BLUE]: '#3b82f6',
  [MainThemeVariants.YELLOW]: '#facc15',
  [MainThemeVariants.VIOLET]: '#6d28d9',
}

export const KM_TO_MILES = 0.621371

export const MILES_TO_KM = 1.60934
